export const SET_CRONOGRAMA = 'SET_CRONOGRAMA'
export const SET_CRONOGRAMAS = 'SET_CRONOGRAMAS'
export const ADD_CRONOGRAMAS = 'ADD_CRONOGRAMAS'
export const UPDATE_CRONOGRAMAS = 'UPDATE_CRONOGRAMAS'
export const REMOVE_CRONOGRAMAS = 'REMOVE_CRONOGRAMAS'